
import {addvirtualroom, delvirtualroom, queryshareroomphone, queryvirtualroomdevice} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'familyManagement',
directives: {
TransferDom
},
data () {
return {
familyList: [],
showFamilyList: [],
owner: 0,
addFamilyShow: false,
hotName1: [{name: '我的家'}, {name: '我的公司'}, {name: '门店'}, {name: '父母家'}],
selectHot1: '',
sendFamily: {
name: '',
level: 1,
parentid: 0
},
showAdd: false,
addText: '成功',
addWarn: false,
warnText: '',
fromPath: '',
memberList: [],
roomDevices: [],

delFamilyShow: false,
selectFamilyDel: ''
}
},
created () {
this.getAllHomeDevice()
document.getElementsByTagName('title')[0].innerText = '场所列表'
},
mounted () {
document.getElementsByTagName('title')[0].innerText = '场所列表'
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
beforeRouteEnter (to, from, next) {
next(vm => {
console.log('from', from)
vm.fromPath = from.path
})
},
methods: {
getAllHomeDevice () {
this.familyList = []
this.showFamilyList = []
this.owner = 0
let roomids = []
this.roomDevices = []
queryvirtualroomdevice().then(res => {
if (res.code === 200) {
if (res.data && res.data.length > 0) {
let arr = res.data
this.roomDevices = arr
for (let i = 0; i < arr.length; i++) {
if (arr[i].level === 1) {
let family = arr[i]
family.roomNum1 = 0
family.roomNum = 0
if (family.role === 'owner') {
this.owner += 1
}
this.familyList.push(family)
roomids.push(arr[i].id)
}
}

this.queryFamilyList(roomids)
}
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {})
},
getFamilyDeviceNum (obj) {
let num = 0
for (let i = 0; i < this.roomDevices.length; i++) {
if (obj.id === this.roomDevices[i].id) { // 场景本身
if (this.roomDevices[i].devices !== null) {
num = num + this.roomDevices[i].devices.length
}
} else if (obj.id === this.roomDevices[i].parentid) { // 分组
if (this.roomDevices[i].devices !== null) {
num = num + this.roomDevices[i].devices.length
}
}
}
return num
},

queryFamilyList (roomids) {
let data = {
roomid: roomids
}
queryshareroomphone(data).then(res => {
if (res.code === 200) {

if (res.data && res.data.length > 0) {
this.memberList = res.data
} else {
this.memberList = []
}
for (let i = 0; i < this.familyList.length; i++) {
this.familyList[i].deviceNum = this.getFamilyDeviceNum(this.familyList[i])
this.familyList[i].roomNum = this.getMemberNum(this.familyList[i].id)
this.familyList[i].roomNum1 = this.getMemberRoom(this.familyList[i].id)
}
this.showFamilyList = this.familyList
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
})
},

getMemberNum (id) {
let num = 0
for (let i = 0; i < this.memberList.length; i++) {
if (id === this.memberList[i].roomid) {
num++
}
}
return num
},

getMemberRoom (id) {
let val = 0
for (let i = 0; i < this.roomDevices.length; i++) {
if (id === this.roomDevices[i].parentid) {
val += 1
}
}
return val
},
getShowBtn (item) {
let aa = true
if (item.deviceNum > 0) { // 有设备的家庭不能删除
aa = false
}
if (item.role === 'owner') { // 保证必须有一个自己的家庭
if (this.owner < 2) {
aa = false
}
}
return aa
},
delHome1 (item) {
this.selectFamilyDel = item
this.delFamilyShow = true
},
delHome () {
let item = this.selectFamilyDel
if (item.deviceNum > 0) { // 有设备的家庭不能删除
return
}
if (item.role === 'owner') { // 保证必须有一个自己的家庭
if (this.owner < 2) {
return
}
}
let data = {
roomid: item.id
}
delvirtualroom(data).then(res => {
if (res.code === 200) {
this.getAllHomeDevice()
this.showAdd = true
this.addText = '成功'
this.delFamilyShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
})
},
openSet (item) {
this.$store.commit('set_family_obj', item)
this.$router.push('/setFamilyItem')
},
addFamily () {
this.sendFamily.name = ''
this.addFamilyShow = true
},
selectHotName1 (item) {
if (this.selectHot1 !== item.name) {
this.selectHot1 = item.name
this.sendFamily.name = this.selectHot1
} else {
this.selectHot1 = ''
this.sendFamily.name = ''
}
},
addHome () {
addvirtualroom(this.sendFamily).then(res => {
if (res.code === 200) {
this.getAllHomeDevice()
this.showAdd = true
this.addText = '成功'
this.addFamilyShow = false
} else {
this.addWarn = true
this.warnText = res.msg
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/more/familyManagement.vue